// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.example-radio-group {
  display: flex;
  flex-direction: column;
  margin: 15px 0;
}

.example-radio-button {
  margin: 5px;
}

.checkbox-slides {
  margin-bottom: 5px;
  height: auto;
}

#SinglePageView .example-radio-group,
.btn-radio-group {
  display: flex;
  flex-direction: row;
  margin: 0;
}

#SinglePageView .form-group {
  margin: 0;
}

mat-form-field,
input {
  width: 100%;
}

.mat-option{
  height: 2em!important;
}


/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVpLXN0eWxlcy5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLGNBQWM7QUFDaEI7O0FBRUE7RUFDRSxXQUFXO0FBQ2I7O0FBRUE7RUFDRSxrQkFBa0I7RUFDbEIsWUFBWTtBQUNkOztBQUVBOztFQUVFLGFBQWE7RUFDYixtQkFBbUI7RUFDbkIsU0FBUztBQUNYOztBQUVBO0VBQ0UsU0FBUztBQUNYOztBQUVBOztFQUVFLFdBQVc7QUFDYjs7QUFFQTtFQUNFLHFCQUFxQjtBQUN2QiIsImZpbGUiOiJ1aS1zdHlsZXMuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmV4YW1wbGUtcmFkaW8tZ3JvdXAge1xyXG4gIGRpc3BsYXk6IGZsZXg7XHJcbiAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcclxuICBtYXJnaW46IDE1cHggMDtcclxufVxyXG5cclxuLmV4YW1wbGUtcmFkaW8tYnV0dG9uIHtcclxuICBtYXJnaW46IDVweDtcclxufVxyXG5cclxuLmNoZWNrYm94LXNsaWRlcyB7XHJcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xyXG4gIGhlaWdodDogYXV0bztcclxufVxyXG5cclxuI1NpbmdsZVBhZ2VWaWV3IC5leGFtcGxlLXJhZGlvLWdyb3VwLFxyXG4uYnRuLXJhZGlvLWdyb3VwIHtcclxuICBkaXNwbGF5OiBmbGV4O1xyXG4gIGZsZXgtZGlyZWN0aW9uOiByb3c7XHJcbiAgbWFyZ2luOiAwO1xyXG59XHJcblxyXG4jU2luZ2xlUGFnZVZpZXcgLmZvcm0tZ3JvdXAge1xyXG4gIG1hcmdpbjogMDtcclxufVxyXG5cclxubWF0LWZvcm0tZmllbGQsXHJcbmlucHV0IHtcclxuICB3aWR0aDogMTAwJTtcclxufVxyXG5cclxuLm1hdC1vcHRpb257XHJcbiAgaGVpZ2h0OiAyZW0haW1wb3J0YW50O1xyXG59XHJcblxyXG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/ui-elements/ui-styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,4qCAA4qC","sourcesContent":[".example-radio-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 15px 0;\r\n}\r\n\r\n.example-radio-button {\r\n  margin: 5px;\r\n}\r\n\r\n.checkbox-slides {\r\n  margin-bottom: 5px;\r\n  height: auto;\r\n}\r\n\r\n#SinglePageView .example-radio-group,\r\n.btn-radio-group {\r\n  display: flex;\r\n  flex-direction: row;\r\n  margin: 0;\r\n}\r\n\r\n#SinglePageView .form-group {\r\n  margin: 0;\r\n}\r\n\r\nmat-form-field,\r\ninput {\r\n  width: 100%;\r\n}\r\n\r\n.mat-option{\r\n  height: 2em!important;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
